import script from "./LabHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabHero.vue?vue&type=script&setup=true&lang=ts"

import "./LabHero.vue?vue&type=style&index=0&id=0ffdf6a9&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ffdf6a9"]])

export default __exports__